import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Plus from "../../../assets/plus.svg";
import server from "../../server";
import DashboardContext from "../Context/DashboardContext";
import ImageUpload from "../Inventory/Layout/ImageUpload";
import BannerTable from "./Layout/BannerTable";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const Banners = () => {
  const [offers, setOffers] = useState([]);
  const context = useContext(DashboardContext);
  const navigate = useNavigate();

  const { setLoading } = context;

  //addbanner modal states
  const [imageFile, setImageFile] = useState(null);
  const [oldbanner, setoldbanner] = useState(null);

  const [open, setOpen] = useState(false);
  const [edit, setedit] = useState(false);
  const [newtitle, setNewTitle] = useState("");
  const [active, setActive] = useState(true);

  //storing all cat , subcat , prod in following 3 states
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [products, setproducts] = useState([]);

  const [catnames, setCatNames] = useState([]);
  const [subcatnames, setSubCatNames] = useState([]);

  //storing selected cat/subcat/prod indices in these states
  const [selectedcat, setSelectedCat] = useState(0);
  const [selectedsubcat, setSelectedSubCat] = useState("");
  const [selectedproduct, setselectedproduct] = useState(null);

  //default values used in case edit is on
  const [defaultcat, setdefaultcat] = useState(null);
  const [defaultsubcat, setdefaultSubcat] = useState(null);
  const [defaultprod, setdefaultprod] = useState(null);

  const [choice, setchoice] = useState(0);
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);

  const handleOpen = () => {
    setedit(false);
    setoldbanner(null);
    setNewTitle("");
    setImageFile(null);
    setActive(true);
    setSelectedCat(0);
    setSelectedSubCat("");
    setselectedproduct(null);
    setchoice(0);
    setOpen(true);
  };

  const handleEditBanner = (banner) => {
    setedit(true);
    setoldbanner(banner);
    setNewTitle(banner.title || "");
    setImageFile(banner.image || null);
    setActive(Boolean(banner.active));

    if (banner.categoryId) {
      setchoice(0);
      const catId = banner.categoryId._id || banner.categoryId;
      const idx = categories ? categories.findIndex((c) => c._id === catId) : -1;
      setSelectedCat(idx >= 0 ? idx : 0);
      setselectedproduct(null);
      setSelectedSubCat("");
    } else if (banner.productId) {
      setchoice(1);
      const prodId = banner.productId._id || banner.productId;
      const prod = products ? products.find((p) => p._id === prodId) : null;
      setselectedproduct(prod || banner.productId || null);
      setSelectedCat("");
      setSelectedSubCat("");
    } else if (banner.subcategoryId) {
      setchoice(2);
      const subId = banner.subcategoryId._id || banner.subcategoryId;
      const idx = subcategories ? subcategories.findIndex((s) => s._id === subId) : -1;
      setSelectedSubCat(idx >= 0 ? idx : 0);
      setSelectedCat("");
      setselectedproduct(null);
    } else {
      // Orphaned or unlinked target
      setchoice(0);
      setSelectedCat(0);
      setselectedproduct(null);
      setSelectedSubCat("");
    }

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setedit(false);
    setoldbanner(null);
    setImageFile(null);
    setNewTitle("");
    setActive(false);
    setSelectedCat(0);
    setSelectedSubCat("");
    setselectedproduct(null);
    setchoice(0);
    setdefaultcat(null);
    setdefaultprod(null);
    setdefaultSubcat(null);
    getOffers();
  };

  const getOffers = async () => {
    setLoading(true);
    try {
      const result = await axios.get(`${server}/banners`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setOffers(result.data || []);
    } catch (error) {
      console.error("Error fetching banners:", error);
      toast.error("Failed to load banners");
    } finally {
      setLoading(false);
    }
  };

  const getcatandsubcat = async () => {
    try {
      //this api gets all categories
      const result = await axios.get(`${server}/public/category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setCategories(result.data || []);
      const arr = (result.data || []).map((element) => element.name);
      setCatNames(arr);

      //this api gets all subcategories
      const subresult = await axios.get(`${server}/subcategories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setSubCategories(subresult.data || []);

      //this api gets all products
      const prodresult = await axios.get(`${server}/admin/products`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setproducts(prodresult.data || []);
    } catch (error) {
      console.error("Error loading categories or products:", error);
    }
  };

  const CreateOffer = async () => {
    if (savingRef.current) return;

    if (!newtitle || !newtitle.trim()) {
      toast.error("Please enter a banner title");
      return;
    }

    if (!imageFile || imageFile === "noimage") {
      toast.error("Please upload a valid banner image");
      return;
    }

    let categoryId = null;
    let productId = null;
    let subcategoryId = null;

    if (choice === 0) {
      if (
        selectedcat === "" ||
        selectedcat === undefined ||
        !categories?.[selectedcat]?._id
      ) {
        toast.error("Please select a valid category");
        return;
      }
      categoryId = categories[selectedcat]._id;
    } else if (choice === 1) {
      if (!selectedproduct?._id) {
        toast.error("Please select a valid product");
        return;
      }
      productId = selectedproduct._id;
    } else if (choice === 2) {
      if (
        selectedsubcat === "" ||
        selectedsubcat === undefined ||
        !subcategories?.[selectedsubcat]?._id
      ) {
        toast.error("Please select a valid subcategory");
        return;
      }
      subcategoryId = subcategories[selectedsubcat]._id;
    }

    const payload = {
      title: newtitle.trim(),
      image: imageFile,
      productId,
      categoryId,
      subcategoryId,
      active: Boolean(active),
    };

    savingRef.current = true;
    setSaving(true);
    setLoading(true);
    try {
      if (edit) {
        if (!oldbanner?._id) {
          toast.error("Missing banner identifier for update");
          return;
        }
        payload.bannerid = oldbanner._id;
        await axios.post(`${server}/banner/edit`, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
      } else {
        await axios.post(`${server}/banner/create`, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
      }
      handleClose();
      toast.success(
        edit ? "Banner updated successfully!" : "Banner created successfully!"
      );
    } catch (error) {
      console.error("Error saving banner:", error);
      toast.error(
        `Error saving banner: ${error?.response?.data?.message || error?.response?.data?.error || error.message}`
      );
    } finally {
      savingRef.current = false;
      setSaving(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("adminuser")) navigate("/");
    else {
      getOffers();
      getcatandsubcat();
    }
  }, []);

  return (
    <div>
      <div className="order-head">
        <p className="order-title">Banner Summary</p>

        <button
          onClick={(e) => {
            e.preventDefault();
            handleOpen();
          }}
        >
          <img alt="plus" src={Plus} loading="eager" />
          Add a New Banner
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "50vw",
              bgcolor: "background.paper",
              borderRadius: "12px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: 1,
              }}
            >
              <Typography
                sx={{
                  marginBottom: "10px",
                  fontWeight: 500,
                }}
              >
                {edit ? <>Edit Banner</> : <>Create New Banner</>}
              </Typography>
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  handleClose();
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "80%" }}>
                <ImageUpload
                  newProduct={[]}
                  setImageFile={setImageFile}
                  imagesSave={typeof imageFile === "string" ? imageFile : ""}
                  isEdit={edit}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  width: "50%",
                  height: "100%",
                }}
              >
                <TextField
                  label="Title"
                  value={newtitle || ""}
                  style={{
                    width: "100%",
                    marginTop: "5px",
                    marginLeft: "5px",
                    backgroundColor: "#EFF1F9",
                  }}
                  onChange={(e) => {
                    setNewTitle(e.target.value);
                  }}
                />

                <FormControl sx={{ mt: 1 }}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={choice}
                    name="radio-buttons-group"
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      setchoice(val);
                      if (val === 0) {
                        setSelectedSubCat("");
                        setselectedproduct(null);
                        setSelectedCat(0);
                      } else if (val === 1) {
                        setSelectedCat("");
                        setSelectedSubCat("");
                      } else if (val === 2) {
                        setSelectedCat("");
                        setselectedproduct(null);
                        setSelectedSubCat(0);
                      }
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio />}
                      label="Category"
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="Product"
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio />}
                      label="SubCategory"
                    />
                  </RadioGroup>
                </FormControl>

                {choice === 0 && (
                  <FormControl
                    variant="outlined"
                    style={{ width: "100%" }}
                    sx={{ margin: 1 }}
                  >
                    <InputLabel id="demo-simple-select-label">Category</InputLabel>
                    <Select
                      sx={{
                        width: "100%",
                        marginTop: "5px",
                        marginLeft: "5px",
                        backgroundColor: "#EFF1F9",
                      }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        selectedcat !== undefined && selectedcat !== null
                          ? selectedcat
                          : ""
                      }
                      label="Select Category"
                      onChange={(e) => {
                        setSelectedCat(e.target.value);
                        setselectedproduct(null);
                        setSelectedSubCat("");
                      }}
                    >
                      {catnames &&
                        catnames.map((element, i) => (
                          <MenuItem key={i} value={i}>
                            {element}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {choice === 1 && (
                  <FormControl
                    variant="outlined"
                    style={{ width: "100%" }}
                    sx={{ margin: 1 }}
                  >
                    <Autocomplete
                      disablePortal
                      id="banner-product-select"
                      options={products || []}
                      value={selectedproduct || null}
                      isOptionEqualToValue={(option, val) =>
                        option?._id === val?._id
                      }
                      getOptionLabel={(option) => option?.name || ""}
                      sx={{
                        width: "100%",
                        marginTop: "5px",
                        marginLeft: "5px",
                        backgroundColor: "#EFF1F9",
                      }}
                      onChange={(event, value) => {
                        setselectedproduct(value || null);
                        setSelectedCat("");
                        setSelectedSubCat("");
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Product" />
                      )}
                    />
                  </FormControl>
                )}

                {choice === 2 && (
                  <FormControl
                    variant="outlined"
                    style={{ width: "100%" }}
                    sx={{ margin: 1 }}
                  >
                    <InputLabel id="subcategory-select-label">
                      SubCategory
                    </InputLabel>
                    <Select
                      sx={{
                        width: "100%",
                        marginTop: "5px",
                        marginLeft: "5px",
                        backgroundColor: "#EFF1F9",
                      }}
                      labelId="subcategory-select-label"
                      id="demo-simple-select"
                      value={
                        selectedsubcat !== undefined && selectedsubcat !== null
                          ? selectedsubcat
                          : ""
                      }
                      label="Select SubCategory"
                      onChange={(e) => {
                        setSelectedSubCat(e.target.value);
                        setSelectedCat("");
                        setselectedproduct(null);
                      }}
                    >
                      {subcategories &&
                        subcategories.map((element, i) => (
                          <MenuItem key={i} value={i}>
                            {element.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                <div
                  className="cash-on-delivery"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    marginTop: "10px",
                  }}
                >
                  <p className="cash-text">Active</p>
                  <AntSwitch
                    checked={Boolean(active)}
                    onChange={(e) => {
                      setActive(e.target.checked);
                    }}
                    inputProps={{
                      "aria-label": "active toggle",
                    }}
                  />
                </div>

                <Button
                  disabled={saving}
                  sx={{
                    backgroundColor: "#5570F1",
                    color: "white",
                    fontWeight: "500",
                    marginTop: "10px",
                    "&.MuiButtonBase-root:hover": {
                      bgcolor: "#5570F1",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#5570F1",
                      color: "white",
                      opacity: 0.7,
                    },
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    CreateOffer();
                  }}
                >
                  {saving ? "Saving..." : "Submit"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </div>
      <div>
        <BannerTable
          offers={offers}
          setoldbanner={setoldbanner}
          setedit={setedit}
          setopen={setOpen}
          setImageFile={setImageFile}
          setdefaultcat={setdefaultcat}
          setdefaultprod={setdefaultprod}
          setdefaultSubcat={setdefaultSubcat}
          setActive={setActive}
          getOffers={getOffers}
          handleEditBanner={handleEditBanner}
        />
      </div>
    </div>
  );
};

export default Banners;
